// extracted by mini-css-extract-plugin
export default {"payfibtn":"Button_payfibtn__mxfFm","payfisecbtn":"Button_payfisecbtn__wap-G","leftIcon":"Button_leftIcon__cnmlk","rightIcon":"Button_rightIcon__Myn8+"};